import { render, staticRenderFns } from "./material-icon-button.vue?vue&type=template&id=26481133&"
import script from "./material-icon-button.vue?vue&type=script&lang=js&"
export * from "./material-icon-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports